import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LanguageSelector from "../Language/LanguageSelector";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import UserManagementActions from "../../Actions/UserManagementActions";
import usermanagementStore from "../../Stores/UsermanagementStore";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import { IsSubDomain } from "../../helpers/isSubDomain";

export default function Branding() {
  const navigate = useNavigate();
  const { language, localization } = useLanguageContext();
  const [orgName, setOrgName] = useState("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [currentDomain, setCurrentDomain] = useState("");
  const currentDomainRef = useRef("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const invalidChar = ["/", "#", "%"];
  useEffect(() => {
    const { domain } = IsSubDomain();
    setCurrentDomain(domain);
    currentDomainRef.current = domain;
  }, []);

  useEffect(() => {
    function getOrgDomainSuccess() {
      var res = usermanagementStore.getOrgDomain();
      const newUrl = `http/SwaOrganisationDummy.localhost:3000`;
      // `${window.location.protocol}//${res.redirectURL}.${currentDomainRef.current}`;
      // history.replace(newUrl, "_self");
      window.open(
        window.location.protocol +
          "//" +
          res.redirectURL +
          "." +
          currentDomainRef.current +
          "?" +
          res.subDoamin,
        "_self",
      );
    }

    function getOrgDomainFailure() {
      var res = usermanagementStore.getOrgDomain();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ORG_DOMAN_SUCCESS,
      getOrgDomainSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_ORG_DOMAN_FAILURE,
      getOrgDomainFailure,
    );
    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ORG_DOMAN_SUCCESS,
        getOrgDomainSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_ORG_DOMAN_FAILURE,
        getOrgDomainFailure,
      );
    };
  }, []);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setOrgName(value);
    const containsInvalidChars = invalidChar.some((char) => {
      if (value.includes(char)) {
        const msg = char + " " + localization.notValidCharacterError;
        setErrorMsg(msg);
        setError(true);
      }
      return value.includes(char);
    });
    if (!containsInvalidChars && error) {
      setErrorMsg("");
      setError(false);
    }
  };

  function handleSubmission(e) {
    e.preventDefault();
    setGlobalSpinner(true);
    UserManagementActions.getOrganDomain(orgName.trim(), language);
  }
  return (
    <>
      <div className="row p-2">
        <div className="col-11 pl-5">
          <div className="brandingHeader"></div>
        </div>
        <div className="col-1 d-flex justify-content-end pr-3">
          <ul id="navigatorBrand">
            <li className="navi-item-listBrand">
              <LanguageSelector />
            </li>
          </ul>
        </div>
      </div>

      <div className="container-fluid brand-full-content">
        <div className="centered-content">
          <div className="row justify-content-center full-width">
            <div
              className=" font-weight-normal"
              style={{ fontSize: "4rem", color: "white" }}
            >
              {localization.brandingHead}
            </div>
          </div>
          <div className="row justify-content-center full-width mt-3">
            <form
              className="formStyleBranding bg-white"
              onSubmit={handleSubmission}
            >
              <div
                className="row  ml-0 mr-0 formStyledire"
                style={{ width: "100%" }}
              >
                <div className="col-5 pl-0 pr-0 formStyleWidth">
                  <input
                    type="text"
                    className={`form-control inputboxHeight p-0 pl-1   ${
                      error ? "inputFiledError" : ""
                    }`}
                    required
                    value={orgName}
                    onChange={handleInputChange}
                    placeholder={localization.enterOrgName}
                  ></input>
                </div>
                <div className="col-4 pl-0 pr-0 formStyleWidth">
                  <span
                    className="input-group-text font-weight-bold domainFont p-3"
                    id="basic-addon2"
                  >
                    {currentDomain}
                  </span>
                </div>
                <div className="col-3 pl-0 pr-0 formStyleWidth">
                  <button
                    className="btn btn-primary btn-block btton p-3"
                    type="submit"
                    disabled={error}
                  >
                    {localization.loginButton}
                  </button>{" "}
                </div>
                {error && (
                  <span className="errorText pl-1" style={{ color: "red" }}>
                    {errorMsg}
                  </span>
                )}
              </div>
            </form>
          </div>

          <div className="mt-3 text-white">
            <p className="mb-0 ">
              <strong> {localization.brandingmsg1}</strong>
            </p>
            <p className="mt-0">{localization.brandingmsg2}</p>
          </div>
        </div>
      </div>

      <div className=" d-flex row mt-auto justify-content-center ">
        © 2023 Graubner GmbH. All rights reserved.Version 1.0.0
      </div>
    </>
  );
}
